import React from 'react';
import MatrimonialPortalRoleComponent from "../components/MatrimonialPortalRoleComponent";
import useStore from "../zustand/useStore";
import MatrimonialDesktopDashboardPage from "../components/MatrimonialDesktopDashboardPage";

export default function MatrimonialDesktopPage({renderHeaderPage,isMobile}) {

    const {userAuthDetail} = useStore();
    const {userInfo} = userAuthDetail;
    if(userInfo?.matrimonial_portal_role) {
        return (
            <MatrimonialDesktopDashboardPage isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
        )
    } else {
        return (
            <MatrimonialPortalRoleComponent isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
        );
    }
}
